import { gql } from '@apollo/client'

const DOWNLOAD_MENU_DOCUMENT_MUTATION = gql`
  mutation downloadMenuDocumentMutation($menuId: ID!) {
    downloadMenuDocument(menuId: $menuId) {
      url
    }
  }
`

export default DOWNLOAD_MENU_DOCUMENT_MUTATION
